import React from "react";
import Section from "./Section";

function LegalPrivacy(props) {
  return (
    <Section
      size="md"
      bgColor="bg-white"
      bgImage=""
      bgImageOpacity={1}
      textColor=""
    >
      <div className="container max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
        
        <div className="prose prose-lg">
          <p className="text-gray-600 mb-6">Last updated: {new Date().toLocaleDateString()}</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">1. Information We Collect</h2>
          <p className="mb-4">
            We collect information that you provide directly to us when making a reservation, including:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Name and contact information (email address, phone number)</li>
            <li>Reservation details (date, time, party size)</li>
            <li>Special requests or dietary requirements</li>
            <li>Payment information (if required for special events)</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">2. How We Use Your Information</h2>
          <p className="mb-4">
            We use the information we collect to:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Process and manage your reservations</li>
            <li>Communicate with you about your reservations</li>
            <li>Send you important updates about our services</li>
            <li>Improve our reservation system and services</li>
            <li>Comply with legal obligations</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">3. Information Sharing</h2>
          <p className="mb-4">
            We do not sell or rent your personal information to third parties. We may share your information with:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Service providers who assist in operating our reservation system</li>
            <li>Law enforcement when required by law</li>
            <li>Other parties with your consent</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">4. Data Security</h2>
          <p className="mb-4">
            We implement appropriate security measures to protect your personal information. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">5. Your Rights</h2>
          <p className="mb-4">
            You have the right to:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your information</li>
            <li>Opt-out of marketing communications</li>
            <li>Object to certain data processing activities</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">6. Cookies and Tracking</h2>
          <p className="mb-4">
            We use cookies and similar tracking technologies to:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Remember your preferences</li>
            <li>Analyze how you use our reservation system</li>
            <li>Improve your experience</li>
          </ul>
          <p className="mb-4">
            You can control cookie settings through your browser preferences.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">7. Children's Privacy</h2>
          <p className="mb-4">
            Our reservation system is not intended for children under 13. We do not knowingly collect personal information from children under 13.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">8. Changes to This Policy</h2>
          <p className="mb-4">
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">9. Contact Us</h2>
          <p className="mb-4">
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p className="mb-4">
            Email: [Your Contact Email]<br />
            Phone: [Your Phone Number]<br />
            Address: [Your Restaurant Address]
          </p>
        </div>
      </div>
    </Section>
  );
}

export default LegalPrivacy;
